<template>
	<div id="testing">
		<div class="row g-3 mb-3 ff-ch">
			<div class="col-lg-8">
				<div class="card h-100">
					<div class="card-header">
						<h5 class="mb-0 lh-base fw-bold mt-2 fs-1"
							>每支影片只能播放 3 次，且不可暫停 / 回拉影片</h5
						>
						<h6 class="c-gray-light mt-2">
							<i
								data-feather="alert-circle"
								width="18"
								stroke-width="2"
							></i>
							<span class=""> 影片播放次數 : {{ remain }}</span>
						</h6>
					</div>
					<div class="card-body position-relative">
						<div class="video_frame">
							<video src="" playsinline ref="video">
								<source type="video/mp4" />
							</video>
							<div
								class="button_play"
								v-show="!isPlay && !isPending"
								@click="play"
							>
								<i
									data-feather="play"
									width="50"
									stroke-width="2"
								></i>
							</div>
							<div class="spinner" v-show="isPending">
								<span class="spinner-border"></span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-4">
				<div class="card h-md-100 ecommerce-card-min-width">
					<div class="card-header">
						<div class="row align-items-center fw-medium">
							<h5 class="col-6 mb-0">
								<span class="c-blue-light fs-1">
									Item
									<span>{{ item }}</span>
								</span>
								<span class="mx-1 c-gray-light fs-0 fw-medium"
									>/ {{ total }}</span
								>
							</h5>
							<router-link
								:to="`/test/${group}`"
								class="col-6 fs-0"
							>
								<p class="text-end c-blue-light">回到表單 ></p>
							</router-link>
						</div>
					</div>

					<div
						class="card-body bg-blue-bg d-flex flex-column justify-content-end"
					>
						<div class="row">
							<div class="py-4">
								<div class="lh-base fs-0">
									{{ test.test }}
								</div>
							</div>
							<div>
								<hr />
							</div>
							<div class="py-4">
								<div
									:class="[
										'py-2 px-2 position-relative',
										{
											correct:
												idx - 1 == test.correct &&
												qa_remain[group - 1] <= 0,
										},
									]"
									v-for="idx in 3"
									:key="idx"
								>
									<input
										type="radio"
										:id="`radio-${idx - 1}`"
										class="me-1 align-middle"
										name="rating"
										v-model="answer"
										:key="`${item}-${idx}`"
										:value="idx - 1"
										:disabled="test.answered !== ''"
									/>
									<label
										:for="`radio-${idx - 1}`"
										:class="[
											'align-middle',
											'fs-0',
											{ disabled: test.answered !== '' },
										]"
										>{{ idx - 1 }}分</label
									>
									<label
										class="fs--1 align-middle fw-bold answer-text"
										v-show="
											idx - 1 == test.correct &&
												qa_remain[group - 1] <= 0
										"
										>answer</label
									>
								</div>
							</div>
						</div>
						<div class="row mt-6">
							<div>
								<div
									:class="[
										'btn',
										{
											'btn-primary': test.answered === '',
											'btn-secondary':
												test.answered !== '',
											'opacity-30': test.answered !== '',
										},
										'mt-3',
										'mt-sm-3',
										'mt-md-6',
										'w-100 fs-0 fw-light ff-ch',
									]"
									@click="answer_submit"
								>
									<i
										data-feather="send"
										width="18"
										stroke-width="2"
									></i>
									送出 (送出後不可更改)
								</div>
							</div>

							<div class="mt-3">
								<div
									class="d-inline-block col-6 align-items-start"
									@click="changeItem('pre')"
									:key="`pre - ${item}`"
									:style="{ opacity: item - 0 > 1 ? 1 : 0 }"
								>
									<p class="c-gray-light fs-0">&lt; 上一題</p>
								</div>

								<div
									class="d-inline-block col-6 align-items-end text-end"
									@click="changeItem('next')"
									:key="`next - ${item}`"
									:style="{
										opacity: item < total ? 1 : 0,
									}"
								>
									<p class="c-gray-light fs-0">下一題 &gt;</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import navTop from "./../nav/NavbarTop.vue";
import Api from "../../script/api";
export default {
	components: {
		navTop,
	},

	data() {
		return {
			AB: ["A", "B"],
			isPlay: false,
			isPending: false,
			answer: "",
		};
	},

	computed: {
		...mapGetters({
			userData: "getUserData",
			token: "getToken",
			remain: "getRemain",
		}),
		group() {
			return this.$route.params.Group;
		},
		series() {
			return this.AB[this.group - 1];
		},
		item() {
			return this.$route.params.index;
		},
		test() {
			let data = null;
			if (this.userData) {
				data = this.userData.qa[this.group - 1].qa.find(
					(item) => item.item === this.item - 0
				);
			}
			return data;
		},
		itemList() {
			return this.userData.qa[this.group - 1].qa.map((item) => item.item);
		},
		total() {
			return this.itemList[this.itemList.length - 1];
		},
		qa_remain() {
			return this.userData.qa.map((item) => item.remain);
		},
	},

	methods: {
		callRemain() {
			const data = {
				series: this.series,
				item: this.item,
			};
			Api.post_header(
				"api/qa_views",
				{ Authorization: `Bearer ${this.token}` },
				data,
				(res) => {
					if (res.res && res.msg === "ok") {
						this.$store.dispatch("handleSetRemain", res.view);
					}
				}
			);
		},
		play() {
			const time = new Date().getTime();

			if (this.remain < 3 || this.qa_remain[this.group - 1] <= 0) {
				this.isPending = true;
				this.$refs.video.src = `${process.env.VUE_APP_API}api/qa_video?token=${this.token}&series=${this.series}&item=${this.item}&${time}`;
			} else {
				alert("影片播放次數已達最大上限");
			}
		},
		answer_submit() {
			if (this.test.answered === "") {
				const data = {
					series: this.series,
					item: this.item,
					answer: this.answer,
				};

				Api.post_header(
					"api/qa_do",
					{ Authorization: `Bearer ${this.token}` },
					data,
					(res) => {
						if (res.res && res.msg === "ok") {
							this.$store.dispatch(
								"handleSetUserData",
								this.token
							);
							this.changeItem("next");
						} else if (res.responseJSON.msg === "輸入參數錯誤") {
							alert("請勾選您的答案");
						}
					}
				);
			}
		},
		changeItem(instruction) {
			const current = this.itemList.indexOf(this.item - 0);
			if (instruction === "pre" && this.item > 1) {
				this.$router.push(
					`/test/${this.group}/${this.itemList[current - 1]}`
				);
				this.answer = this.test.answered;
			} else if (instruction === "next" && this.item < this.total) {
				this.$router.push(
					`/test/${this.group}/${this.itemList[current + 1]}`
				);
				this.answer = this.test.answered;
			}

			this.isPlay = false;
			this.isPending = false;
			this.$refs.video.src = "";
		},
		handleVideoEvent(event) {
			if (event.type === "loadedmetadata") {
				this.isPlay = true;
				this.isPending = false;
				this.callRemain();
				this.$refs.video.play();
			}
			if (event.type === "ended") {
				this.isPlay = false;
			}
		},
	},

	created() {
		this.$store.commit("navLeftSwitch", "");
		this.answer = this.test.answered;
		this.callRemain();
	},

	mounted() {
		feather.replace();
		this.$refs.video.addEventListener("loadstart", this.handleVideoEvent);
		this.$refs.video.addEventListener("ended", this.handleVideoEvent);
		this.$refs.video.addEventListener(
			"loadedmetadata",
			this.handleVideoEvent
		);
	},

	watch: {
		item(nv, ov) {
			this.callRemain();
		},
	},
};
</script>

<style lang="scss" scoped>
.video_frame {
	position: relative;
	width: 100%;
	background-color: rgba(0, 0, 0, 1);
	z-index: 0;
}

video {
	position: relative;
	width: 100%;
	height: auto;
	z-index: 1;
}

.d-inline-block.col-6 {
	cursor: pointer;
	user-select: none;
}

.disabled {
	color: var(--falcon-600);
}

.correct {
	background-color: rgba(#00ffa7, 0.4);
}

.opacity-30 {
	opacity: 0.3 !important;
}

.answer-text {
	position: absolute;
	right: 10px;
	top: 50%;
	transform: translateY(-50%);
	color: #00d995;
}

.card-body {
	padding-top: 0;
}

.spinner {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	.spinner-border {
		border: 0.25em solid rgba(white, 0.9);
		border-right-color: transparent;
	}
}

@media screen and (max-width: 992px) {
	#testing {
		.row.ff-ch {
			.col-lg-4 {
				.card {
					.card-body {
						.mt-6 {
							margin-top: 0 !important;
						}
					}
				}
			}
		}
	}
}
</style>
